'use strict'

export default (message, datasetId) => `${message} (${datasetId})`
